import { render, staticRenderFns } from "./BarCodeScanner.vue?vue&type=template&id=6d76d0c4"
import script from "./BarCodeScanner.vue?vue&type=script&lang=js"
export * from "./BarCodeScanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports